var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "icon icon-tabler icons-tabler-outline icon-tabler-calendar-stats",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.795 21h-6.795a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14v4h4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3v4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3v4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11h16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsume);
export default __webpack_public_path__ + "static/media/consume.f8794040599c448e698f9932ec4684bf.svg";
export { ForwardRef as ReactComponent };